<template>
  <div id="submit-manuscripts-upload-documents-loading">
    <ipub-model :title="'Review Result Details'"
                width="600px"
                :visable="isVisable"
                :showFooter="false"
                :showHeader="false"
                @cancel="cancel">
      <div class="upload-documents-loading">
        <div class="mar-b-20">
          <ipub-icon style="font-size:80px"
                     type="icona-UploadManuscript" />
        </div>
        <div v-if="ftype&&ftype.length>0 &&hasUploadFiles">
          <div v-for="item in hasUploadFiles"
               :key="'ftype'+item.id">
            <div class="tl mar-b-4">{{ item.typeName }}</div>
            <div class="upload-documents-loading-wrap mar-b-10"
                 v-if="item.typeName === 'Cover Letter' ">
              <div v-show="!item.file.path"
                   :style="{width:(progress.current1.toFixed(0))+'%'}"
                   class="upload-documents-loading-content"></div>
              <div v-show="item.file.path"
                   :style="{width:(100)+'%'}"
                   class="upload-documents-loading-content"></div>
            </div>
            <div class="upload-documents-loading-wrap mar-b-10"
                 v-else-if="item.typeName === 'Manuscript (Word/ZIP)'">
              <div v-show="!item.file.path"
                   :style="{width:(progress.current2.toFixed(0))+'%'}"
                   class="upload-documents-loading-content"></div>
              <div v-show="item.file.path"
                   :style="{width:(100)+'%'}"
                   class="upload-documents-loading-content"></div>
            </div>
            <div class="upload-documents-loading-wrap mar-b-10"
                 v-else-if="item.typeName === 'Manuscript (PDF Version)'">
              <div v-show="!item.file.path"
                   :style="{width:(progress.current3.toFixed(0))+'%'}"
                   class="upload-documents-loading-content"></div>
              <div v-show="item.file.path"
                   :style="{width:(100)+'%'}"
                   class="upload-documents-loading-content"></div>
            </div>
            <div class="upload-documents-loading-wrap mar-b-10"
                 v-else-if="item.typeName === 'Graphical Abstract'">
              <div v-show="!item.file.path"
                   :style="{width:(progress.current4.toFixed(0))+'%'}"
                   class="upload-documents-loading-content"></div>
              <div v-show="item.file.path"
                   :style="{width:(100)+'%'}"
                   class="upload-documents-loading-content"></div>
            </div>
            <div class="upload-documents-loading-wrap mar-b-10"
                 v-else-if="item.typeName === 'Supplementary Material'">
              <div v-show="!item.file.path"
                   :style="{width:(progress.current5.toFixed(0))+'%'}"
                   class="upload-documents-loading-content"></div>
              <div v-show="item.file.path"
                   :style="{width:(100)+'%'}"
                   class="upload-documents-loading-content"></div>
            </div>
            <div class="upload-documents-loading-wrap mar-b-10"
                 v-else-if="item.typeName === 'Figure(s)'">
              <div v-show="!item.file.path"
                   :style="{width:(progress.current6.toFixed(0))+'%'}"
                   class="upload-documents-loading-content"></div>
              <div v-show="item.file.path"
                   :style="{width:(100)+'%'}"
                   class="upload-documents-loading-content"></div>
            </div>
            <div class="upload-documents-loading-wrap mar-b-10"
                 v-else-if="item.typeName === 'Table(s)'">
              <div v-show="!item.file.path"
                   :style="{width:(progress.current7.toFixed(0))+'%'}"
                   class="upload-documents-loading-content"></div>
              <div v-show="item.file.path"
                   :style="{width:(100)+'%'}"
                   class="upload-documents-loading-content"></div>
            </div>
            <div class="upload-documents-loading-wrap mar-b-10"
                 v-else-if="item.typeName === 'Dataset(s)'">
              <div v-show="!item.file.path"
                   :style="{width:(progress.current8.toFixed(0))+'%'}"
                   class="upload-documents-loading-content"></div>
              <div v-show="item.file.path"
                   :style="{width:(100)+'%'}"
                   class="upload-documents-loading-content"></div>
            </div>
            <div class="upload-documents-loading-wrap mar-b-10"
                 v-else-if="item.typeName === 'Video(s)'">
              <div v-show="!item.file.path"
                   :style="{width:(progress.current9.toFixed(0))+'%'}"
                   class="upload-documents-loading-content"></div>
              <div v-show="item.file.path"
                   :style="{width:(100)+'%'}"
                   class="upload-documents-loading-content"></div>
            </div>
            <div class="tr font-color ipub-p2"
                 v-if="item.typeName === 'Cover Letter'">
              <div v-show="!item.file.path">Uploading… {{progress.current1.toFixed(0)}}%</div>
              <div v-show="item.file.path">Uploaded {{100}}%</div>
            </div>
            <div class="tr font-color ipub-p2"
                 v-else-if="item.typeName === 'Manuscript (Word/ZIP)'">
              <div v-show="!item.file.path">Uploading… {{progress.current2.toFixed(0)}}%</div>
              <div v-show="item.file.path">Uploaded {{100}}%</div>
            </div>
            <div class="tr font-color ipub-p2"
                 v-else-if="item.typeName === 'Manuscript (PDF Version)'">
              <div v-show="!item.file.path">Uploading… {{progress.current3.toFixed(0)}}%</div>
              <div v-show="item.file.path">Uploaded {{100}}%</div>
            </div>
            <div class="tr font-color ipub-p2"
                 v-else-if="item.typeName === 'Graphical Abstract'">
              <div v-show="!item.file.path">Uploading… {{progress.current4.toFixed(0)}}%</div>
              <div v-show="item.file.path">Uploaded {{100}}%</div>
            </div>
            <div class="tr font-color ipub-p2"
                 v-else-if="item.typeName === 'Supplementary Material'">
              <div v-show="!item.file.path">Uploading… {{progress.current5.toFixed(0)}}%</div>
              <div v-show="item.file.path">Uploaded {{100}}%</div>
            </div>
            <div class="tr font-color ipub-p2"
                 v-else-if="item.typeName === 'Figure(s)'">
              <div v-show="!item.file.path">Uploading… {{progress.current6.toFixed(0)}}%</div>
              <div v-show="item.file.path">Uploaded {{100}}%</div>
            </div>
            <div class="tr font-color ipub-p2"
                 v-else-if="item.typeName === 'Table(s)'">
              <div v-show="!item.file.path">Uploading… {{progress.current7.toFixed(0)}}%</div>
              <div v-show="item.file.path">Uploaded {{100}}%</div>
            </div>
            <div class="tr font-color ipub-p2"
                 v-else-if="item.typeName === 'Dataset(s)'">
              <div v-show="!item.file.path">Uploading… {{progress.current8.toFixed(0)}}%</div>
              <div v-show="item.file.path">Uploaded {{100}}%</div>
            </div>
            <div class="tr font-color ipub-p2"
                 v-else-if="item.typeName === 'Video(s)'">
              <div v-show="!item.file.path">Uploading… {{progress.current9.toFixed(0)}}%</div>
              <div v-show="item.file.path">Uploaded {{100}}%</div>
            </div>
          </div>

        </div>

      </div>
    </ipub-model>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    isVisable: {
      type: Boolean,
      default: false,
    },
    ftype: {
      type: Array,
      default () {
        return []
      }
    },
    hasUploadFiles: {
      type: Array,
      default () {
        return []
      }
    },
    progress: {
      type: Object,
      default () {
        return {
          current1: 0,
          current2: 0,
          current3: 0,
          current4: 0,
          current5: 0,
          current6: 0,
          current7: 0,
          current8: 0,
          current9: 0,
        }
      }
    },
  },
  data () {
    return {
      progressObj: {}
    }
  },
  computed: {
    ...mapGetters({
      domain: 'getDomain',
    })
  },
  watch: {
    isVisable (val) {
      if (!val) {
        this.progressObj = {}
      } else {

        this.hasUploadFiles.map(item => {
          if (item.file.path) {
            // console.log(item.file.path)
            // console.log(this.progress.current9, 'sdsdsds');
          } else if (!item.file.path) {
            // console.log('dfsdfs');
          }
        })
        // console.log(this.ftype);
        this.progressObj = JSON.parse(JSON.stringify(val))

      }
    },
  },

  methods: {
    cancel () {
      this.progress.current1 = 0
      this.progress.current2 = 0
      this.progress.current3 = 0
      this.progress.current4 = 0
      this.progress.current5 = 0
      this.progress.current6 = 0
      this.progress.current7 = 0
      this.progress.current8 = 0
      this.progress.current9 = 0

      this.$emit('cancel')
    },
  }
}
</script>

<style lang="scss" scoped>
#submit-manuscripts-upload-documents-loading {
  .upload-documents-loading {
    text-align: center;
    &-wrap {
      width: 100%;
      height: 4px;
      background: $line_color;
    }
    &-content {
      width: 50%;
      height: 100%;
      background: $main_color;
      transition: 0.3s all;
    }
  }
}
</style>
